import React, { useState } from 'react'
import { Dialog, DialogContent, DialogTrigger } from 'src/components/dialogue/radix-dialog';
import { Product } from '../../types/products';
import EditProductForm from './EditProductForm';

const EditProductModal = ({ children, product }: { children: React.ReactNode, product: Product }) => {

  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger>{children}</DialogTrigger>
      <DialogContent className="w-full max-w-5xl max-h-[70vh] bg-white">
        <div>
          <div className="p-8 border-b border-slate-100 flex justify-between items-center bg-slate-50">
            <div className="flex flex-col">
              <h3 className="text-2xl font-black text-slate-900 uppercase tracking-tight">
                Modify Inventory Asset
              </h3>
              <p className="text-[10px] font-bold text-emerald-600 uppercase tracking-widest mt-1">
                Editing {product.name}
              </p>
            </div>
          </div>
          <EditProductForm product={product} close={handleClose}/>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EditProductModal